import * as types from './types';
import createReducer from '../../createReducer';
import { getLocaleDatetimeFormat, getLocaleDatetimeFormatLower } from 'utils/utils';
import { FETCH_STATE } from 'constants';

const initialState = {
  account: null,
  loading: false,
  accountDetails: null,
  availablesBrokers: [],
  publicBastions: [],
  organization: {},
  localeFormat: getLocaleDatetimeFormat(),
  localeFormatLower: getLocaleDatetimeFormatLower(),
  errors: {},
  fetchingAvailablesBrokers: false,
  fetchedUploadLogoSuccess: false,
  fetchedUpdateOrgSuccess: false,
  organizationToBrokers: [],
  currentOrganizationToBroker: null,
  fetchingEditOrganizationToBrokers: false,
  errorfetchingEditOrganizationToBrokers: null,
  fetchedDeleteOrganizationsToBrokers: FETCH_STATE.UNSENT,
  fetchedEditOrganizationToBrokers: FETCH_STATE.UNSENT,
  fetchedOrganizationToBroker: FETCH_STATE.UNSENT,
  brokerSchema: null,
};

const organizationReducer = createReducer(initialState)({
  [types.FETCH_PUBLIC_ORGANIZATIONS_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      publicBastions: [],
    };
  },
  [types.FETCH_PUBLIC_ORGANIZATIONS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      publicBastions: payload,
    };
  },
  [types.FETCH_PUBLIC_ORGANIZATIONS_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
      publicBastions: [],
    };
  },
  // GET ORGANIZATION BY ID
  [types.FETCH_ORGANIZATION_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_ORGANIZATION_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      organization: payload,
      localeFormat: getLocaleDatetimeFormat(payload?.locale),
      localeFormatLower: getLocaleDatetimeFormatLower(payload?.locale),
    };
  },
  [types.FETCH_ORGANIZATION_BY_ID_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },
  // UPDATE ORGANIZATION
  [types.FETCH_UPDATE_ORGANIZATION_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      fetchedUpdateOrgSuccess: false,
    };
  },
  [types.FETCH_UPDATE_ORGANIZATION_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      organization: payload,
      localeFormat: getLocaleDatetimeFormat(payload?.locale),
      localeFormatLower: getLocaleDatetimeFormatLower(payload?.locale),
      fetchedUpdateOrgSuccess: true,
    };
  },
  [types.FETCH_UPDATE_ORGANIZATION_FAILED]: (state, { errors }) => {
    return {
      ...state,
      loading: false,
      fetchedUpdateOrgSuccess: false,
      errors,
    };
  },
  // UPLOAD ORGANIZATION LOGO
  [types.UFETCH_PLOAD_ORGANIZATION_LOGO_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      fetchedUploadLogoSuccess: false,
    };
  },
  [types.UFETCH_PLOAD_ORGANIZATION_LOGO_SUCCESS]: (state) => {
    return {
      ...state,
      loading: false,
      fetchedUploadLogoSuccess: true,
    };
  },
  [types.FETCH_UPLOAD_ORGANIZATION_LOGO_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
      fetchedUploadLogoSuccess: false,
    };
  },
  // RESET UPDATE ORGANIZATION
  [types.RESET_UPDATE_ORGANIZATION_SUCCESS]: (state) => {
    return {
      ...state,
      fetchedUpdateOrgSuccess: false,
      errors: {},
    };
  },
  // RESET UPDATE ORGANIZATION
  [types.RESET_UPLOAD_ORGANIZATION_LOGO_SUCCESS]: (state) => {
    return {
      ...state,
      fetchedUploadLogoSuccess: false,
    };
  },

  // GET AVAILABLES BROKERS
  [types.FETCH_AVAILABLES_BROKERS_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      fetchingAvailablesBrokers: true,
    };
  },
  [types.FETCH_AVAILABLES_BROKERS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      fetchingAvailablesBrokers: false,
      availablesBrokers: payload?.data,
    };
  },
  [types.FETCH_AVAILABLES_BROKERS_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
      fetchingAvailablesBrokers: false,
    };
  },

  // CREATE ACCOUNT ONBOARDING
  [types.FETCH_CREATE_PAYMENT_ACCOUNT_REQUEST]: (state) => {
    return {
      ...state,
      fetchingAccount: true,
    };
  },
  [types.FETCH_CREATE_PAYMENT_ACCOUNT_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      account: payload,
      fetchingAccount: false,
      accountDetails: payload?.status,
    };
  },
  [types.FETCH_CREATE_PAYMENT_ACCOUNT_FAILED]: (state) => {
    return {
      ...state,
      fetchingAccount: false,
    };
  },
  [types.FETCH_PAYMENT_ONBOARD_REQUEST]: (state) => {
    return {
      ...state,
      fetchingAccount: true,
      account: null,
    };
  },
  [types.FETCH_PAYMENT_ONBOARD_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingAccount: false,
      account: payload,
    };
  },
  [types.FETCH_PAYMENT_ONBOARD_FAILED]: (state) => {
    return {
      ...state,
      account: null,
      fetchingAccount: false,
    };
  },
  [types.FETCH_ACCOUNT_DETAILS_REQUEST]: (state) => {
    return {
      ...state,
      fetchingAccount: true,
    };
  },
  [types.FETCH_ACCOUNT_DETAILS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingAccount: false,
      accountDetails: payload,
    };
  },
  [types.FETCH_ACCOUNT_DETAILS_FAILED]: (state) => {
    return {
      ...state,
      fetchingAccount: false,
    };
  },
  [types.FETCH_LINK_PAYMENT_ACCOUNT_REQUEST]: (state) => {
    return {
      ...state,
      account: null,
      fetchingAccount: true,
    };
  },
  [types.FETCH_LINK_PAYMENT_ACCOUNT_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      account: payload,
      fetchingAccount: false,
    };
  },
  [types.FETCH_LINK_PAYMENT_ACCOUNT_FAILED]: (state) => {
    return {
      ...state,
      fetchingAccount: false,
    };
  },
  [types.FETCH_RESET_CREATE_ACCOUNT_ONBOARDING]: (state) => {
    return {
      ...state,
      account: null,
      fetchingAccount: false,
    };
  },
  [types.FETCH_DELETE_ORGANIZATION_TO_BROKERS_REQUEST]: (state) => {
    return {
      ...state,
      fetchedDeleteOrganizationsToBrokers: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_DELETE_ORGANIZATION_TO_BROKERS_SUCCESS]: (state) => {
    return {
      ...state,
      fetchedDeleteOrganizationsToBrokers: FETCH_STATE.DONE,
    };
  },
  [types.FETCH_DELETE_ORGANIZATION_TO_BROKERS_FAILED]: (state) => {
    return {
      ...state,
      fetchedDeleteOrganizationsToBrokers: FETCH_STATE.ERROR,
    };
  },
  [types.FETCH_EDIT_ORGANIZATION_TO_BROKERS_REQUEST]: (state) => {
    return {
      ...state,
      fetchingEditOrganizationToBrokers: true,
      errorfetchingEditOrganizationToBrokers: null,
      fetchedEditOrganizationToBrokers: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_EDIT_ORGANIZATION_TO_BROKERS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingEditOrganizationToBrokers: false,
      errorfetchingEditOrganizationToBrokers: null,
      fetchedEditOrganizationToBrokers: FETCH_STATE.DONE,
      organizationToBrokers: [...state.organizationToBrokers, payload],
    };
  },
  [types.FETCH_EDIT_ORGANIZATION_TO_BROKERS_FAILED]: (state, { errors }) => {
    return {
      ...state,
      errorfetchingEditOrganizationToBrokers: errors,
      fetchingEditOrganizationToBrokers: false,
      fetchedEditOrganizationToBrokers: FETCH_STATE.ERROR,
    };
  },
  [types.FETCH_ORGANIZATION_TO_BROKER_REQUEST]: (state) => {
    return {
      ...state,
      fetchedOrganizationToBroker: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_ORGANIZATION_TO_BROKER_SUCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchedOrganizationToBroker: FETCH_STATE.DONE,
      currentOrganizationToBroker: payload,
    };
  },
  [types.FETCH_ORGANIZATION_TO_BROKER_FAILED]: (state) => {
    return {
      ...state,
      fetchedOrganizationToBroker: FETCH_STATE.ERROR,
    };
  },
  [types.RESET_ORGANIZATION_TO_BROKER]: (state) => {
    return {
      ...state,
      fetchedEditOrganizationToBrokers: FETCH_STATE.UNSENT,
    };
  },
  [types.FETCH_BROKER_SCHEMA_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      brokerSchema: null,
    };
  },
  [types.FETCH_BROKER_SCHEMA_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      brokerSchema: payload,
    };
  },
  [types.FETCH_BROKER_SCHEMA_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
      brokerSchema: null,
    };
  },
  [types.FETCH_RESET_BROKER_SCHEMA]: (state) => {
    return {
      ...state,
      loading: false,
      brokerSchema: null,
      fetchingEditOrganizationToBrokers: false,
    };
  },
});

export default organizationReducer;
